import _ from 'lodash';

import { ILevelGeneralData, levelGeneralData } from 'src/app/infrastructure/models/level-general-data';
import { IClaimActionForm } from './claim-action-form';
import { IClaimActionDto, claimActionDto } from 'src/assets/common/models/claim-action-dto.g';
import { ILevelDomainData, levelDomainData } from 'src/app/infrastructure/models/level-domain-data';

export interface IClaimActionCache {
    data: IClaimActionData;
    url: string;
}

export const claimActionData = {
    ...levelDomainData,
    guid: 'guid',
    nr: 'nr',
    name: 'name',
    deleted: 'deleted',
    inactive: 'inactive',
} as const;

export type TClaimActionData = (typeof claimActionData)[keyof typeof claimActionData];

export interface IClaimActionData extends ILevelDomainData
{
    [claimActionData.guid]: string;
    [claimActionData.nr]: number | null;
    [claimActionData.name]: string | null;
    [claimActionData.deleted]: boolean;
    [claimActionData.inactive]: boolean;
}

export class ClaimActionData
    implements IClaimActionData, ILevelGeneralData
{
    [claimActionData.guid]!: string;
    [claimActionData.nr]: number | null = null;
    [claimActionData.name]: string | null = null;
    [claimActionData.deleted]!: boolean;
    [claimActionData.inactive]!: boolean;

    protected constructor(modelDto?: IClaimActionDto | null);
    protected constructor(modelData: IClaimActionData, modelForm: IClaimActionForm);
    protected constructor(value?: IClaimActionDto | IClaimActionData | null, modelForm?: IClaimActionForm) {
        if (!!modelForm) {
            const _modelData = value as IClaimActionData;
            _.assign(this, _modelData, modelForm);
        } else if (!!value) {
            const _modelDto = value as IClaimActionDto;

            this[claimActionData.guid] = _modelDto[claimActionDto.guid]!;
            this[claimActionData.nr] = _modelDto[claimActionDto.nr];
            this[claimActionData.name] = _modelDto[claimActionDto.name];
            this[claimActionData.deleted] = _modelDto[claimActionDto.deleted]!;
            this[claimActionData.inactive] = _modelDto[claimActionDto.inactive]!;
        }
    }
        
    static create(modelDto?: IClaimActionDto | null): IClaimActionData | null
    static create(modelData: IClaimActionData, modelForm: IClaimActionForm): IClaimActionData | null
    static create(value?: IClaimActionDto | IClaimActionData | null, modelForm?: IClaimActionForm): IClaimActionData | null {

        if (!!modelForm) {
            const _modelData = value as IClaimActionData;
            return new ClaimActionData(_modelData, modelForm);
        } else {
            const _modelDto = value as IClaimActionDto;
            return _modelDto ? new ClaimActionData(_modelDto) : null;
        }
    }
}
